import { Box } from '@mui/material';

export const BurgerMenu = ({
  isActive,
  setMenuActive,
  children,
}) => {
  const handleCloseMenu = () => {
    setMenuActive(false);
  };

  return (
    <Box
      component={'div'}
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        minHeight: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        backdropFilter: 'blur(8px)',
        zIndex: 1999,
        opacity: isActive ? 1 : 0,
        pointerEvents: isActive ? 'auto' : 'none',
        transition: 'opacity 300ms ease 100ms',
      }}
      onClick={handleCloseMenu}
    >
      <Box
        component={'div'}
        sx={{
          position: 'fixed',
          width: '336px',
          height: '100%',
          zIndex: 2000,
          right: 0,
          top: 0,
          overflowY: 'auto',
          transition: 'all 300ms ease 100ms',
          opacity: isActive ? 1 : 0,
          pointerEvents: isActive ? 'auto' : 'none',
        }}
        onClick={e => e.stopPropagation()}
      >
        {children}
      </Box>
    </Box>
  );
};
